import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Image from '../../image/image.js';
import './infoBand.css';

class InfoBand extends Component {
  static defaultProps = {
    slider: false,
  }
  render() {
    const { field_longtext_1, field_text_1, field_image } = this.props.config;
    if (this.props.slider === true) {
      return (
        <div className="infoBand" style={{
          border: "1px solid #ccc",
          padding: "24px",
          float: "left",
          width: "100%",
          background: "#ebebeb",
          paddingBottom: "2em",
        }}>
          {typeof field_image === 'undefined'?null:<div style={{ float: "left", padding:"0 3% 1% 0" }}><Image imageStyle="155" media={field_image} /></div>}
          {typeof field_text_1 === 'undefined'?null:<h3 style={{
            marginLeft:"170px",
            borderBottom:"1px solid rgb(206, 206, 206)",
            textTransform:"uppercase",}}>{field_text_1.replace(/&#039;/g, "'").replace(/&quot;/g, '"')}</h3>}
          {typeof field_longtext_1 === 'undefined'?null:ReactHtmlParser(field_longtext_1)}
        </div>
      );
    } else {
      return (
        <div className="infoBand" style={{
          borderBottom: "2px dashed #ccc",
          float: "left",
          //width: "100%",
          paddingTop: "1em",
        }}>
          {typeof field_text_1 === 'undefined'?null:<h2>{field_text_1.replace(/&#039;/g, "'").replace(/&quot;/g, '"')}</h2>}
          {typeof field_image === 'undefined'?null:<div style={{ float: "left", padding:"0 3% 1% 0" }}><Image imageStyle="155" media={field_image} /></div>}
          {typeof field_longtext_1 === 'undefined'?null:ReactHtmlParser(field_longtext_1)}
        </div>
      );
    }
  }
}

export default InfoBand;
